/** Contratos de rotas internas /api/v1 — único lugar para paths de API. */

const base = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ?? ''

export const API_ROUTES = {
  whatsapp: {
    enviar: `${base}/api/v1/whatsapp/enviar`,
    simularRecebida: `${base}/api/v1/whatsapp/simular-recebida`,
    webhook: `${base}/api/v1/webhooks/whatsapp`,
  },
  admin: {
    medicos: `${base}/api/v1/admin/medicos`,
    workspaces: `${base}/api/v1/admin/workspaces`,
  },
} as const

/** Monta URL absoluta do webhook (prod: origin atual ou APP_URL no servidor). */
export function webhookWhatsAppUrl(origin?: string): string {
  const o = origin ?? (typeof window !== 'undefined' ? window.location.origin : '')
  return `${o.replace(/\/$/, '')}/api/v1/webhooks/whatsapp`
}

/** Fetch autenticado com token da sessão Supabase. */
export async function apiFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const { createClient } = await import('@/lib/supabase/client')
  const supabase = createClient()
  const { data: { session } } = await supabase.auth.getSession()
  const headers = new Headers(init.headers)
  if (session?.access_token) {
    headers.set('Authorization', `Bearer ${session.access_token}`)
  }
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }
  return fetch(input, { ...init, headers })
}
